/**
 * TanStack Query hooks for `post-attribution-fraud-detection`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	postAttributionFraudDetectionQueryKeys,
	type CreatePostAttributionFraudDetectionBody,
	type ListPostAttributionFraudDetectionResponse,
	type PostAttributionFraudDetectionRow,
} from "./api";

export function usePostAttributionFraudDetectionList(): UseQueryResult<ListPostAttributionFraudDetectionResponse, Error> {
	return useQuery({
		queryKey: postAttributionFraudDetectionQueryKeys.list(),
		queryFn: list,
	});
}

export function usePostAttributionFraudDetectionCreate(): UseMutationResult<PostAttributionFraudDetectionRow, Error, CreatePostAttributionFraudDetectionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postAttributionFraudDetectionQueryKeys.all });
		},
	});
}

export function usePostAttributionFraudDetectionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postAttributionFraudDetectionQueryKeys.all });
		},
	});
}
